import { validatorCreator } from 'utils/helpers/validators/validatorCreator'
import { areOnlyDigits } from 'utils/helpers/input'

export const VALIDATION_ERRORS_ENUM = {
  CANNOT_BE_EMPTY: 'This field is required.',
  VALUE_INVALID: 'Only digits are allowed.',
}

const numberInRangeValidators = [
  {
    name: 'Field cannot be empty',
    isValid: ({ value, isRequired }) => !isRequired || (isRequired && areOnlyDigits(value)),
    errorMessage: VALIDATION_ERRORS_ENUM.CANNOT_BE_EMPTY,
  },
  {
    name: 'Is entered correct',
    isValid: ({ value }) => (value && areOnlyDigits(value)) || !value,
    errorMessage: VALIDATION_ERRORS_ENUM.VALUE_INVALID,
  },
  {
    name: 'Is value in range',
    isValid: ({ value, min = 0, max = 1000 }) =>
      (value && areOnlyDigits(value) && value >= min && value <= max) || !value,
    errorMessageCreator: ({ min, max }) => `Value should be in range ${min} - ${max}`,
  },
]

export const validateNumberInRange = validatorCreator(numberInRangeValidators)
